// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const InvoiceReport = lazy(
  () => import('pages/reports/reportsDirectory/queryReport')
);

const InvoiceReportRoute = (
  <Route path={routeName.invoiceReport}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.DOWNLOAD_INVOICE_REPORT}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <InvoiceReport pageType="invoice" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default InvoiceReportRoute;
